
import { IMessage, IInteractionContext, IRecognizerResult } from "../engine";
import { IInteractionRecognized } from "./interaction";
import { BaseModel } from "./baseModel";
import { Bot } from "./bot";
import { Workspace } from "./workspace";

export interface Activity extends BaseModel {
    bot: Bot,
    workspace: Workspace,
    conversationId: string;
    incoming: IMessage;
    outcoming?: IMessage[];
    recognizerResult?: IRecognizerResult<IInteractionRecognized>;
    context: IInteractionContext<IInteractionRecognized>;
    data?: any;
}

export enum ActivityType {
    typing = 'typing',
    event = 'event',
    message = 'message',
    end_conversation = 'end_conversation',
    suspend_conversation = 'suspend_conversation',
    rating = 'rating',
    printscreen = 'printscreen',
    member_added = 'member_added',
    member_disconnected = 'member_disconnected',
    member_connected = 'member_connected',
    member_removed = 'member_removed',
    member_exit = 'member_exit',
    member_reconnected = 'member_reconnected',
    member_upload_attachment = 'member_upload_attachment',
    bot_took_on = 'bot_took_on',
    bot_disconnected = 'bot_disconnected',
    error = 'error',
    note = 'note',
    comment = 'comment',
    assigned_to_team = 'assigned_to_team',
    rating_message = 'rating_message',
    member_removed_by_admin = 'member_removed_by_admin',
}

export function ActivityIsBilled(activityType : ActivityType ) {
    return ActivityType.message == activityType || 
        ActivityType.member_upload_attachment == activityType;
}